import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Search, AlertCircle } from 'lucide-react';

const NotFound: React.FC = () => {
  const [searchQuery, setSearchQuery] = React.useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    // Implement search functionality here
    console.log('Search query:', searchQuery);
  };

  return (
    <div className="min-h-screen bg-bg-primary flex items-center justify-center py-16 px-4">
      <div className="container-custom max-w-2xl">
        <div className="glass-card p-8 md:p-12 text-center animate-fadeIn">
          <div className="mb-8 text-gradient-from">
            <AlertCircle size={64} className="mx-auto" aria-hidden="true" />
          </div>

          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Page Not Found
          </h1>

          <p className="text-text-secondary text-lg mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>

          {/* Search Form */}
          <form onSubmit={handleSearch} className="mb-8">
            <div className="relative max-w-md mx-auto">
              <input
                type="search"
                placeholder="Search our site..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full px-4 py-3 rounded-lg bg-bg-secondary border border-white/10 text-text-light placeholder:text-text-secondary focus:outline-none focus:border-gradient-from focus:ring-1 focus:ring-gradient-from"
                aria-label="Search"
              />
              <button
                type="submit"
                className="absolute right-3 top-1/2 -translate-y-1/2 text-text-secondary hover:text-gradient-from"
                aria-label="Submit search"
              >
                <Search size={20} aria-hidden="true" />
              </button>
            </div>
          </form>

          {/* Quick Links */}
          <div className="space-y-4">
            <h2 className="text-xl font-semibold mb-4">
              Popular Destinations
            </h2>
            <nav className="grid gap-4 md:grid-cols-2" aria-label="Popular pages">
              <Link
                to="/#copytrading"
                className="flex items-center justify-center gap-2 p-4 rounded-lg bg-bg-secondary hover:bg-white/5 transition-colors"
              >
                Start Copy-Trading
              </Link>
              <Link
                to="/#results"
                className="flex items-center justify-center gap-2 p-4 rounded-lg bg-bg-secondary hover:bg-white/5 transition-colors"
              >
                View Performance
              </Link>
              <Link
                to="/#faq"
                className="flex items-center justify-center gap-2 p-4 rounded-lg bg-bg-secondary hover:bg-white/5 transition-colors"
              >
                FAQ
              </Link>
              <Link
                to="/terms"
                className="flex items-center justify-center gap-2 p-4 rounded-lg bg-bg-secondary hover:bg-white/5 transition-colors"
              >
                Terms & Privacy
              </Link>
            </nav>
          </div>

          {/* Return Home Button */}
          <div className="mt-8">
            <Link
              to="/"
              className="btn btn-accent inline-flex items-center gap-2"
            >
              <Home size={20} aria-hidden="true" />
              Return Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;